import { toast } from "react-toastify";
import {
  fetchReservationTrendsFailure,
  fetchReservationTrendsSuccess,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_RESERVATION_ANALYTICS_API } from "../../constants/constants";
import { getCurrentWeekRange } from "../../../Components/Utils/UtilityFunctions";

export const getReservationTrends =
  (setLoading, dateRange) => async (dispatch) => {
    setLoading(true);
    const currentWeekRange = getCurrentWeekRange();
    await determineBaseUrlAndPerformApiCall(
      `${GET_RESERVATION_ANALYTICS_API}?period=${dateRange?.period || "3m"}${
        dateRange?.period === "custom"
          ? `&trendFrom=${dateRange?.from}&trendTo=${dateRange?.to}`
          : ""
      }&heatmapFrom=${currentWeekRange?.from}&heatmapTo=${
        currentWeekRange?.to
      }`,
      "GET"
    )
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          dispatch(fetchReservationTrendsSuccess(response || {}));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchReservationTrendsSuccess({}));
          } else {
            dispatch(fetchReservationTrendsFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch((errorResp) => {});
  };
